import cookie from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

//set in cookie
export const setCookie = (key, value) => {
    if (window !== 'undefined') {
        cookie.set(key, value, {
            expires: 7
        })
    }
}

//remove from cookie
export const removeCookie = (key) => {
    if (window !== 'undefined') {
        cookie.remove(key, {
            expires: 1
        })
    }
}

//get from cookie such as stored token
export const getCookie = (key) => {
    if (window !== 'undefined') {
        return cookie.get(key)
    }
}

export const authenticate = (response, next) => {
    setCookie('token', response.data.token)
    next()
}


export const isAuth = () => {
    if (typeof window !== 'undefined') {
        const token = getCookie('token');

        if (!token) {
            return false;
        }

        try {
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000; // Prevod na sekundy

            // Ak je aktuálny čas väčší ako čas expirácie v tokene
            if (decoded.exp < currentTime) {
                console.warn("Token expiroval.");
                // Voliteľné: Tu môžeš cookie rovno zmazať
                removeCookie('token'); 
                return false;
            }

            return true;
        } catch (error) {
            console.error("Chybný formát tokenu");
            return false;
        }
    }
};

// export const isAuth = () => {
//     // return true

//     if (window !== 'undefined') {
//         const cookieChecked = getCookie('token')
//         if (cookieChecked) {
//             return true
//         }
//         return false

//     }
// }
export const signout = () => {
    removeCookie('token')
}